export const text = {
  STREET_ADDRESS_1: 'Street address 1*',
  STREET_ADDRESS_2: 'Street address 2',
  CITY: 'City',
  STATE: 'State',
  ZIP_CODE: 'Zip code',
  STREET_NUMBER_KEY: 'street_number',
  ROUTE_KEY: 'route',
  LOCALITY_KEY: 'locality',
  ADMINISTRATIVE_AREA_LEVEL_1_KEY: 'administrative_area_level_1',
  POSTAL_CODE_KEY: 'postal_code',
  COUNTRY: 'country',
  PREFERRED_PHARMACY_TEXT: 'Preferred pharmacy',
}
const statesAddressDropdownList = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]
export const sortedStatesAddressDropdownList = statesAddressDropdownList.sort((a, b) => {
  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  if (a[0] < b[0]) {
    return -1
  }

  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  if (a[0] > b[0]) {
    return 1
  }

  if (a[0] === b[0]) {
    // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
    if (a[1] < b[1]) {
      return -1
    }
    // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
    if (a[1] > b[1]) {
      return 1
    }
  }

  return 0
})
